import { FAVOURITES_ENUM } from "./types";

interface FavouriteItem {
  id: string;
  date: number;
}

type ReturnType = {
  opportunities: Record<string, number>;
  organisations: Record<string, number>;
};

export function getFavouritesFromCookie(): ReturnType {
  const favourites = Object.values(FAVOURITES_ENUM).reduce((acc, cur) => {
    const list = getListFromCookie(cur);
    acc[cur] = list.reduce((innerAcc, innerCur) => {
      innerAcc[innerCur.id] = innerCur.date;
      return innerAcc;
    }, {});
    return acc;
  }, {});

  return {
    opportunities: favourites[FAVOURITES_ENUM.OPPORTUNITY],
    organisations: favourites[FAVOURITES_ENUM.ORGANISATION],
  };
}

function getListFromCookie(type: FAVOURITES_ENUM) {
  let listOfFavourites: FavouriteItem[] = [];

  if (typeof document !== "undefined" && document?.cookie) {
    const favCookie = document.cookie
      .split(";")
      .find((c) => c.trim().startsWith(`f_${type}=`))
      ?.split("=")[1];

    if (favCookie) {
      const decoded = decodeURIComponent(decodeURIComponent(favCookie) || "");
      listOfFavourites = (Object.entries(JSON.parse(decoded)) || []).map(
        ([id, date]) => ({ id, date } as FavouriteItem)
      );
    }
  }

  return listOfFavourites;
}
